





























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";
// TODO document2
import { Design } from "@/model/document2/page/surface/design/design";
import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { TableLayer } from "@/model/document2/page/surface/design/layer/tableLayer";

import CommonPosition from "./commonPosition/commonPosition.vue";

import PlainTextStyle from "./plainTextStyle/plainTextStyle.vue";
import TextShadow from "./textShadow/textShadow.vue";
import SimpleTextShadow from "./simpleTextShadow/simpleTextShadow.vue";
import RoundTextStyle from "./roundTextStyle/roundTextStyle.vue";
import ThreedTextStyle from "./threedTextStyle/threedTextStyle.vue";
import PlainTextStyleSelected from "./plainTextStyleSelected/plainTextStyleSelected.vue";
import SimpleTextStyle from "./simpleTextStyle/simpleTextStyle.vue";

import RectangleStyle from "./rectangleStyle/rectangleStyle.vue";
import PolygonStyle from "./polygonStyle/polygonStyle.vue";
import PolygonOperate from "./polygonOperate/polygonOperate.vue";
import CircleStyle from "./circleStyle/circleStyle.vue";
import SpecialPatternStyle from "./specialPatternStyle/specialPatternStyle.vue";
// import PatternColor from "./patternColor/patternColor.vue";
import PatternColorFillNone from "./patternColorFillNone/patternColorFillNone.vue";
import PatternColorFillSolid from "./patternColorFillSolid/patternColorFillSolid.vue";
import PatternColorFillGradient from "./patternColorFillGradient/patternColorFillGradient.vue";

import ImageStyle from "./imageStyle/imageStyle.vue";
import ImageShadow from "./imageShadow/imageShadow.vue";
import ImageClipping from "./imageClipping/imageClipping.vue";

import LineStyle from "./lineStyle/lineStyle.vue";
import CurveStyle from "./curveStyle/curveStyle.vue";
import LinePosition from "./linePosition/linePosition.vue";

import QRcodeStyle from "./qrcodeStyle/qrcodeStyle.vue";
import BarcodeStyle from "./barcodeStyle/barcodeStyle.vue";

import TableAll from "./tableAll/tableAll.vue";
import TableCell from "./tableCell/tableCell.vue";

import CalendarCommonStyle from "./calendarCommonStyle/calendarCommonStyle.vue";
import CalendarDayStyle from "./calendarDayStyle/calendarDayStyle.vue";
import CalendarYearStyle from "./calendarYearStyle/calendarYearStyle.vue";
import CalendarMonthStyle from "./calendarMonthStyle/calendarMonthStyle.vue";
import CalendarWeekDayStyle from "./calendarWeekDayStyle/calendarWeekDayStyle.vue";

import NumberTextStyleTop from "./numberTextStyleTop/numberTextStyleTop.vue";
import NumberTextStyle from "./numberTextStyle/numberTextStyle.vue";
import NumberTextShadow from "./numberTextShadow/numberTextShadow.vue";

import DateTextStyle from "./dateTextStyle/dateTextStyle.vue";
import DateTextShadow from "./dateTextShadow/dateTextShadow.vue";

import GroupPosition from "./groupPosition/groupPosition.vue";

//複数選択をした時、選択された複数のオブジェクトのタイプの組み合わせに限らず、常に表示される
import MultiplePosition from "./multiplePosition/multiplePosition.vue";

//複数選択をした時、選択された複数のオブジェクトのタイプ全てテキストだった時に、表示される
import MultipleTextStyle from "./multipleTextStyle/multipleTextStyle.vue";
import MultipleTextShadow from "./multipleTextShadow/multipleTextShadow.vue";

//複数選択をした時、選択された複数のオブジェクトのタイプ全て画像だった時に、表示される
import MultipleImageStyle from "./multipleImageStyle/multipleImageStyle.vue";
import MultipleImageShadow from "./multipleImageShadow/multipleImageShadow.vue";

//複数選択をした時、選択された複数のオブジェクトのタイプ全て図形だった時に、表示される
import MultiplePatternStyle from "./multiplePatternStyle/multiplePatternStyle.vue";
import MultiplePatternColorFillNone from "./multiplePatternColorFillNone/multiplePatternColorFillNone.vue";
import MultiplePatternColorFillSolid from "./multiplePatternColorFillSolid/multiplePatternColorFillSolid.vue";
import MultiplePatternColorFillGradient from "./multiplePatternColorFillGradient/multiplePatternColorFillGradient.vue";

import { TextLayer } from "@/model/document2/page/surface/design/layer/textLayer";
import { PlainTextLayer } from '@/model/document2/page/surface/design/layer/plainTextLayer';
import { ImageLayer } from '@/model/document2/page/surface/design/layer/imageLayer';
import { RectangleLayer } from '@/model/document2/page/surface/design/layer/rectangleLayer';
import { CircleLayer } from '@/model/document2/page/surface/design/layer/circleLayer';
import { PolygonLayer } from '@/model/document2/page/surface/design/layer/polygonLayer';
import { SpecialPatternLayer } from '@/model/document2/page/surface/design/layer/specialPatternLayer';
import { SimpleTextLayer } from '@/model/document2/page/surface/design/layer/simpleTextLayer';

@Component({
  components: {
    CommonPosition,
    PlainTextStyle,
    TextShadow,
    SimpleTextShadow,
    RoundTextStyle,
    ThreedTextStyle,
    PlainTextStyleSelected,
    SimpleTextStyle,
    RectangleStyle,
    PolygonStyle,
    PolygonOperate,
    CircleStyle,
    SpecialPatternStyle,
    // PatternColor,
    PatternColorFillNone,
    PatternColorFillSolid,
    PatternColorFillGradient,
    ImageStyle,
    ImageShadow,
    ImageClipping,
    LineStyle,
    CurveStyle,
    LinePosition,
    QRcodeStyle,
    BarcodeStyle,
    TableAll,
    GroupPosition,
    TableCell,
    CalendarCommonStyle,
    CalendarDayStyle,
    CalendarYearStyle,
    CalendarMonthStyle,
    CalendarWeekDayStyle,
    NumberTextStyleTop,
    NumberTextStyle,
    NumberTextShadow,
    DateTextStyle,
    DateTextShadow,
    MultiplePosition,
    MultipleTextStyle,
    MultipleTextShadow,
    MultipleImageStyle,
    MultipleImageShadow,
    MultiplePatternStyle,
    MultiplePatternColorFillNone,
    MultiplePatternColorFillSolid,
    MultiplePatternColorFillGradient
  }
})
export default class RightController extends Vue 
{
    @Prop() private design! : Design;
    @Prop() private layer! : Layer;

    private get layerType()
    {
        // 複数レイヤーのときはタイプを返さない
        if(this.design.selectLayers.length > 1) { return ""; }
        return this.layer.layerType;
    }

    get editMode(): number {
        return this.$store.getters.applicationState.editMode;
    }
    changeEditMode(editMode: number) {
        this.$store.dispatch("changeEditMode", editMode);
    }

    private get nextCommandText()
    {
        var flowMode = this.$store.getters.applicationState.flowMode;
        if(flowMode == 1 || flowMode == 2 || flowMode == 3)
        {
            return "次へ";
        }
        else
        {
            return "レイアウトへ";
        }
    }

    // 表示条件が特殊なライトコントローラ
    private isVisible(name) 
    {
        // 複数レイヤーのときは表示しない
        if(this.isVisibleMultipleType > 0) { return false; }

        var isVisible = false;
        if (name == "plainTextStyle") 
        {
            // 通常文字/スタイル: テキストが編集中でない、もしくは選択文字列がないとき
            if (this.layer.layerType == "plainText" && this.layer instanceof TextLayer) 
            {
                isVisible = !this.layer.inEdit || this.layer.startPosition == this.layer.endPosition;
            }
        } 
        else if (name == "plainTextStyleSelected") 
        {
            // 通常文字/スタイル(一部選択): テキストが編集中であり、選択文字列があるとき
            if (this.layer.layerType == "plainText" && this.layer instanceof TextLayer) 
            {
                isVisible = this.layer.inEdit && this.layer.startPosition != this.layer.endPosition;
            }
        }
        else if (name == "roundTextStyle") 
        {
            // 円周文字/スタイル
            isVisible = this.layer.layerType == "circleText";
        }
        else if (name == "threedTextStyle")
        {
            // 3D文字/スタイル
            isVisible = this.layer.layerType == "d3Text";
        }
        else if(name == "tableAll")
        {
            // 表(全体)
            if(this.layer instanceof TableLayer)
            {
                isVisible = this.layer.currentRow < 0 || this.layer.currentColumn < 0;
            }
        }
        else if(name == "tableCell")
        {
            // 表(セル)
            if(this.layer instanceof TableLayer)
            {
                isVisible = this.layer.currentRow >= 0 && this.layer.currentColumn >= 0;
            }
        }

        return isVisible;
    }

    // 複数レイヤー表示タイプ
    // 0: 表示しない
    // 1: 位置調整
    // 2: テキスト
    // 3: 画像
    // 4: 図形(塗りつぶしなし)
    // 5: 図形(単色)
    // 6: 図形(グラデーション)
    private get isVisibleMultipleType()
    {
        // 複数レイヤー扱いするのは以下のケース
        // 1)選択レイヤーが複数ある
        // 2)カレントがグループで、かつ選択レイヤーが1つ以上ある
        var selectedLayers = this.design.getSelectLayerWithoutGroup();
        if(selectedLayers.length > 1 ||
        (this.design.currentLayer != null && this.design.currentLayer.layerType == "group" && selectedLayers.length >= 1))
        {
            // タイプ

            // グループがカレントのときは1(位置調整)を返す
            if(this.design.currentLayer != null && this.design.currentLayer.layerType == "group") { return 1; }

            var multipleType = 1;
            // 塗りタイプ(0: なし, 1: 単色, 2: グラデーション)
            var multipleFillType = 0;
            for(var i = 0; i < selectedLayers.length; ++i)
            {
                var selectedLayer = selectedLayers[i];
                var type = 1;
                var fillType = 0;
                if(selectedLayer instanceof PlainTextLayer || selectedLayer instanceof SimpleTextLayer)
                {
                    type = 2;
                }
                else if(selectedLayer instanceof ImageLayer)
                {
                    type = 3;
                }
                else if(selectedLayer instanceof RectangleLayer || selectedLayer instanceof CircleLayer || 
                  selectedLayer instanceof PolygonLayer || selectedLayer instanceof SpecialPatternLayer)
                {
                    type = 4;
                    fillType = selectedLayer.fillType;
                }

                if(i == 0)
                {
                    multipleType = type;
                    multipleFillType = fillType;
                }
                else
                {
                    if(multipleType != type)
                    {
                        // 違うレイヤータイプが出現
                        multipleType = 1;
                    }
                    if(multipleFillType != fillType)
                    {
                        // 違う塗りタイプが出現
                        multipleFillType = 0;
                    }
                }
            }

            if(multipleType == 4)
            {
                // 塗りタイプを足して最終的なレイヤータイプとする
                multipleType += multipleFillType;
            }

            return multipleType;
        }
        else
        {
            return 0;
        }
    }

    private onDoCommand(command: string, paramater: any) 
    {
        this.$emit("doCommand", command, paramater);
    }
    
    private onClickReplaceTemplate()
    {
        this.$emit("doCommand", "replaceTemplate", null);
    }

    private onClickToLayout() 
    {
        this.$emit("doCommand", "toLayout", null);
    }

    isExportVisible = false;

    private get userConfigBackGroundColor()
    {
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
  
}
